module.exports = "../../app/cells/components/campaigns/widgets/countdown_progress_cell.rb";